<form>

</form>
<nz-table #table mm-table [entityName]="'extensionMeta'">
    <thead>
        <tr>
            <td></td>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let item of table.data">
            <td></td>
        </tr>

    </tbody>
</nz-table>